import React, { useMemo } from 'react';
import {
    StepLayout,
    MultiStepButtons,
    MultilineText,
    TextInput,
    Icon,
    ICON_SIZE_NAMES,
    IconNames,
    Heading,
} from '@dekafvv/sharedfrontend';
import { useLanguage } from '@hydrogen/elements.core.i18n';
import { useDispatch } from 'react-redux';
import { setForgotPasswordAnswers } from 'redux/forgotPassword/forgotPasswordActions';
import { TFormProps } from 'features/PageForm';

const forgotPasswordFieldName = { name: 'email' };

export const ForgotPasswordOverview: React.FC<Props> = ({
    onNext,
    formProps,
}) => {
    const { t } = useLanguage();

    const dispatch = useDispatch();

    const {
        onChange, errors, values, handleSubmit,
    } = formProps;

    const handleOnNext = handleSubmit((val) => {
        dispatch(setForgotPasswordAnswers({
            email: val[forgotPasswordFieldName.name],
        }));

        onNext(val);
    });

    const onNextBtn = useMemo(() => ({
        title: t('button.send'),
        action: handleOnNext,
    }), [handleOnNext, t]);

    return (
        <StepLayout>
            <div className="flex flex-col gap-8 p-8 items-center">
                <Icon
                    name={IconNames.informationFilled}
                    size={ICON_SIZE_NAMES.xl}
                    color="var(--blue-90)"
                />
                <Heading textAlign="center" size={2}>
                    {t('wizard.forgot-password.header')}
                </Heading>
                <MultilineText fontWeight="bold">
                    {t('wizard.forgot-password.text')}
                </MultilineText>
                <TextInput
                    type="email"
                    label={t('wizard.forgot-password.field')}
                    aria-label="Email Address"
                    onChange={onChange(forgotPasswordFieldName.name)}
                    error={errors[forgotPasswordFieldName.name]}
                    value={values(forgotPasswordFieldName.name) || ''}
                    className="mt-30 w-80"
                />
                <MultiStepButtons onNext={onNextBtn} />
            </div>
        </StepLayout>
    );
};

type Props = {
    onNext: (val: { [key: string]: string }) => void;
    formProps: TFormProps;
};
